import { useRenderNotifier } from '@wui/common-library'
import { AxiosResponse } from 'axios'

import { useLocalization } from '@/shared/composables/localization'
import { CallBack } from '@/shared/types/api'
import { getAppURL } from '@/shared/utils/electron'
import { useFetchApi, FetchResponse } from '@/shared/utils/fetch'

interface ICallBackAPI {
  loadAllCallBack: () => Promise<AxiosResponse<CallBack[]> | FetchResponse<CallBack[]>>
  deleteCallBack: (callBackGuid: string) => Promise<AxiosResponse<void> | FetchResponse<void>>
  saveCallBackService: (callBack: Omit<CallBack, 'guid'>) => Promise<AxiosResponse<void> | FetchResponse<void>>
}

export function callBackAPI (): ICallBackAPI {
  const useFetch = useFetchApi()
  const { t } = useLocalization()
  const { notifyError } = useRenderNotifier()

  const loadAllCallBack = (): Promise<AxiosResponse<CallBack[]> | FetchResponse<CallBack[]>> => {
    try {
      return useFetch.get<CallBack[]>(getAppURL({ pathName: '/api/call-back' }))
    } catch (e) {
      notifyError(t('mainAside.errorOnSave'))
      throw e
    }
  }

  const deleteCallBack = (callBackGuid: CallBack['guid']): Promise<AxiosResponse<void> | FetchResponse<void>> => {
    try {
      return useFetch.delete<void>(getAppURL({ pathName: `/api/call-back/${callBackGuid}` }))
    } catch (e) {
      notifyError(t('mainAside.errorOnSave'))
      throw e
    }
  }

  const saveCallBackService = (callBack: Omit<CallBack, 'guid'>): Promise<AxiosResponse<void> | FetchResponse<void>> => {
    try {
      return useFetch.post<void>(getAppURL({ pathName: '/api/call-back' }), callBack)
    } catch (e) {
      notifyError(t('mainAside.errorOnSave'))
      throw e
    }
  }

  return {
    loadAllCallBack,
    deleteCallBack,
    saveCallBackService,
  }
}
